import supabase from '../supabaseClient'
import { TABLE_NAMES } from '../config'
import { isCommunityManager } from './signupFunnelRedirect'

/**
 * Returns membership info when the user already belongs to a community
 * (Users.community_id is set). Otherwise null.
 */
export async function fetchExistingCommunityMembership(userId) {
  if (!userId) return null

  const { data: userProfile, error: profileError } = await supabase
    .from(TABLE_NAMES.USERS)
    .select('community_id')
    .eq('user_id', userId)
    .maybeSingle()

  if (profileError || !userProfile?.community_id) return null

  const { data: communityData } = await supabase
    .from(TABLE_NAMES.COMMUNITIES)
    .select('name')
    .eq('id', userProfile.community_id)
    .maybeSingle()

  return {
    communityId: userProfile.community_id,
    communityName: communityData?.name || 'your community',
  }
}

/**
 * Allow the community signup / setup wizard only when the user has no
 * community in the database yet.
 */
export function shouldAllowCommunitySignupFlow(userCommunityId) {
  return !userCommunityId
}

export function communityLoginRedirectState(communityName) {
  return { alreadyInCommunity: communityName || 'your community' }
}

/**
 * Returns membership info when the user is already a community manager.
 * Otherwise null.
 */
export async function fetchExistingCommunityManagerMembership(userId) {
  if (!userId) return null

  const { data: userProfile, error: profileError } = await supabase
    .from(TABLE_NAMES.USERS)
    .select('community_id, community_manager')
    .eq('user_id', userId)
    .maybeSingle()

  if (profileError || !userProfile?.community_id || !isCommunityManager(userProfile)) {
    return null
  }

  const { data: communityData } = await supabase
    .from(TABLE_NAMES.COMMUNITIES)
    .select('name')
    .eq('id', userProfile.community_id)
    .maybeSingle()

  return {
    communityId: userProfile.community_id,
    communityName: communityData?.name || 'your community',
  }
}
